import { z } from 'zod';
import { QuoteDepositType } from '@trnsact/trnsact-shared-types';
import { SaleType } from 'modules/desking';
import { SendVia, SendEmailOption, EmailOptionGroups } from '../types';

export const contactsStepSchema = z.object({
  ownerPgIds: z.array(z.string()),
  accountContactIds: z.array(z.string()),
});

export const equipmentStepSchema = z.object({
  selectedId: z.string().nullable(),
});

export const tradeInListingItemSchema = z.object({
  // Equipment record id backing this trade-in; null until the first autosave creates it
  equipmentId: z.string().nullable(),
  make: z.string().nullable(),
  model: z.string().nullable(),
  year: z.string().nullable(),
  newUsed: z.string().nullable(),
  serialNumberVin: z.string().nullable(),
  mileage: z.number().nullable(),
  tradeInValue: z.number().nullable(),
  amountOwed: z.number().nullable(),
  otherCharges: z.number().nullable(),
  netTrade: z.number().nullable(),
  /* additionalDescription: z.string().nullable(), */
});

export const pricingStepSchema = z.object({
  lineItems: z.array(z.record(z.string(), z.unknown())),
  customerDeposit: z.object({
    type: z.nativeEnum(QuoteDepositType),
    value: z.number(),
    notes: z.string(),
  }),
  tradeIn: z.array(tradeInListingItemSchema),
});

export const financeMenuStepSchema = z.object({
  isEnabled: z.boolean(),
  saleType: z.nativeEnum(SaleType),
});

const sendEmailOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
  fullName: z.string(),
  email: z.string().email(),
  title: z.string(),
  phone: z.string().optional(),
  group: z.nativeEnum(EmailOptionGroups),
});

export const reviewSendStepSchema = z.object({
  notesToBuyer: z.string().nullable(),
  sendVia: z.nativeEnum(SendVia),
  sendEmailTo: sendEmailOptionSchema.array().optional(),
  ccEmails: sendEmailOptionSchema.array().optional(),
});

export const dealBuilderFormSchema = z.object({
  contacts: contactsStepSchema,
  equipment: equipmentStepSchema,
  pricing: pricingStepSchema,
  financeMenu: financeMenuStepSchema,
  reviewSend: reviewSendStepSchema,
});
